import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TrEmailComponent } from './tr-email.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [ TrEmailComponent ],
    declarations: [ TrEmailComponent ],
})
export class TrEmailModule {}
